export default function Patreon() {
    return <div class="patreons row justify-content-md-end art-deco position-relative">
        <div class="col-md-6 d-flex flex-column justify-content-center align-items-center">
            <p>Thanks to my Patreons for helping me with the server cost</p>
            <h2>Peter F, Sebafaim, Andrew J, Jeffrey I, Adam, Mic Tom, Stephane C, Jeremy H and Arthur</h2>
        </div>
    </div>
}